import { IDPContainer } from '../../b2c/IDPContainer.mjs';
import { createB2CComponent } from '../bindings/createB2CComponent.mjs';

/**
 * The Stytch IDP component.
 * Parses OAuth Authorization params (client_id, scope, nonce, etc.) out of the page URL.
 * Requires the user to be logged in.
 * This component can only be used with a Stytch UI Client
 * passed into the StytchProvider.
 *
 * See the {@link https://stytch.com/docs/sdks online reference}
 *
 * @example
 * <IdentityProvider
 *   presentation={{
 *     theme: { primary: '#ff00f7' },
 *     options: {},
 *   }}
 *   callbacks={{
 *     onEvent: (event) => console.log(event)
 *   }}
 * />
 */ const IdentityProvider = /* @__PURE__ */ createB2CComponent('IdentityProvider', IDPContainer);

export { IdentityProvider };
//# sourceMappingURL=IdentityProvider.mjs.map
